import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './AlreadyPaidScreen.module.scss';
export const GetAlreadyPaidScreenTID = (parentTestId)=>getTestIds(parentTestId);
export const AlreadyPaidScreen = (param)=>{
    let { invoiceNumber, amount, onDownloadPdf, testId } = param;
    const { AlreadyPaidScreenTestIds } = GetAlreadyPaidScreenTID(testId);
    const { t } = useLocaleKeys();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": AlreadyPaidScreenTestIds.Root(),
        className: styles.screen,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h3",
                testId: AlreadyPaidScreenTestIds.Title(),
                className: styles.title,
                children: t.adHocInvoiceApproval.alreadyPaid.title()
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.row,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        weight: "normal",
                        children: t.adHocInvoiceApproval.alreadyPaid.invoiceNumberLabel()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        testId: AlreadyPaidScreenTestIds.InvoiceNumber(),
                        children: invoiceNumber
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.row,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        weight: "normal",
                        children: t.adHocInvoiceApproval.alreadyPaid.amountLabel()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        testId: AlreadyPaidScreenTestIds.Amount(),
                        children: amount.display()
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                skin: "primary",
                testId: AlreadyPaidScreenTestIds.DownloadPdfButton(),
                onClick: onDownloadPdf,
                children: t.adHocInvoiceApproval.alreadyPaid.downloadPdf()
            })
        ]
    });
};
